import { HISTORY_BLOCK_RECEIVE, HISTORY_BLOCK_ERROR } from './HistoryBlock.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const HistoryReducer = (state = defaultState, action) => {
    switch (action.type) {
        case HISTORY_BLOCK_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case HISTORY_BLOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}